module.exports = __webpack_public_path__ + "img/pazuru-blog.2d206101.png";